import React, { useState, useEffect } from "react";
import { Formik, Field, Form } from "formik";
import * as Yup from "yup"; // Import Yup for schema validation
import { IoChatbubble } from "react-icons/io5";
import { ChatIcon } from "../../assets/icons/icons";
import toast, { Toaster } from "react-hot-toast";
import { FaWhatsapp } from "react-icons/fa";
import dayjs from "dayjs";
import { postApi } from "../../services/apiController";

const ChatBot = () => {
  const [open, setOpen] = useState(false);
  const [showPopupText, setShowPopupText] = useState(false);
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

  const messages = [
    "Have any doubt?",
    "Send us an enquiry!",
    "Connect with an expert!",
  ];

  useEffect(() => {
    const showTimer = setTimeout(() => {
      setShowPopupText(true);
    }, 5000); // Show after 3 seconds

    return () => {
      clearTimeout(showTimer);
    };
  }, []);
  useEffect(() => {
    let messageTimer;
    if (showPopupText) {
      messageTimer = setInterval(() => {
        setCurrentMessageIndex(
          (prevIndex) => (prevIndex + 1) % messages.length
        );
      }, 10000); // Change message every 4 seconds
    }

    return () => {
      clearInterval(messageTimer);
    };
  }, [showPopupText]);

  // Yup validation schema
  const validationSchema = Yup.object().shape({
    name: Yup.string().trim().required("Name is required"),
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    mob_no: Yup.string()
      .matches(/^\d+$/, "Invalid contact number")
      .required("Contact number is required"),
    message: Yup.string().trim().required("Message is required"),
  });

  const handleWhatsappClick = () => {
    const initialMessage = encodeURIComponent(
      "Hello, I have an enquiry about your services."
    );
    window.open(`https://wa.me/917742386069?text=${initialMessage}`, "_blank");
  };

  const handleFormSubmit = async (values) => {
    try {
      setOpen(false);
      const formattedValues = {
        ...values,
        date: dayjs(values.date).format("DD/MM/YYYY"), // Format date here
      };
      // delete formattedValues.destination;
      const res = await postApi("postQuery", formattedValues);
      // const data = res.json();
      toast("Enquiry submitted successfully");
      setOrderPopup(false);
    } catch (error) {
      toast(res.message);
    } finally {
    }
  };

  return (
    <div className="relative">
      <Formik
        initialValues={{
          name: "",
          email: "",
          mob_no: "",
          message: "",
        }}
        validationSchema={validationSchema} // Attach Yup validation schema
        onSubmit={handleFormSubmit}
      >
        {({ errors, touched }) => (
          <>
            {open ? (
              <Form className="fixed bg-gray-100 bottom-5 right-5 w-[95vw] text-gray-700 max-w-md p-8 shadow-lg rounded-xl z-50 flex flex-col gap-4">
                {/* Close Button */}
                <button
                  type="button"
                  className="absolute top-2 right-3 text-gray-600 hover:text-red-500"
                  onClick={() => setOpen(false)}
                >
                  ✕
                </button>

                {/* Heading and Quote */}
                <div className="text-center mb-2">
                  <h2 className="text-xl font-bold text-indigo-600">
                    Need Help Planning Your Trip?
                  </h2>
                </div>

                {/* Name Field */}
                <Field
                  name="name"
                  type="text"
                  placeholder="Name*"
                  className="border border-gray-300 rounded-lg px-4 py-2 focus:ring focus:ring-indigo-300"
                />
                {errors.name && touched.name && (
                  <div className="text-red-500 text-sm">{errors.name}</div>
                )}

                {/* Email Field */}
                <Field
                  name="email"
                  type="email"
                  placeholder="Email*"
                  className="border border-gray-300 rounded-lg px-4 py-2 focus:ring focus:ring-indigo-300"
                />
                {errors.email && touched.email && (
                  <div className="text-red-500 text-sm">{errors.email}</div>
                )}

                {/* Mobile Number Field */}
                <Field
                  name="mob_no"
                  type="text"
                  placeholder="Contact Number*"
                  className="border border-gray-300 rounded-lg px-4 py-2 focus:ring focus:ring-indigo-300"
                />
                {errors.mob_no && touched.mob_no && (
                  <div className="text-red-500 text-sm">{errors.mob_no}</div>
                )}

                {/* Message Field */}
                <Field
                  as="textarea"
                  name="message"
                  rows="4"
                  placeholder="Message*"
                  className="border border-gray-300 rounded-lg px-4 py-2 focus:ring focus:ring-indigo-300"
                />
                {errors.message && touched.message && (
                  <div className="text-red-500 text-sm">{errors.message}</div>
                )}

                {/* Submit Button */}
                <button
                  type="submit"
                  className="bg-indigo-500 text-white py-2 rounded-lg shadow hover:bg-indigo-600 focus:ring focus:ring-indigo-300"
                >
                  Submit
                </button>
              </Form>
            ) : (
              <div className="fixed bottom-5 right-5 z-20 flex items-center">
                {showPopupText && (
                  <div className="md:bg-teal-500 bg-green-500 text-white animate-jump animate-slide-in-out px-4 py-2 rounded-md">
                    {messages[currentMessageIndex]}
                  </div>
                )}
                <button
                  className="w-12 h-12 bg-teal-500 md:flex hidden text-white rounded-full shadow-lg items-center justify-center hover:bg-blue-600 focus:ring focus:ring-blue-300 animate-jump"
                  onClick={() => setOpen(true)}
                >
                  <ChatIcon />
                </button>
                <button
                  onClick={handleWhatsappClick}
                  className="text-white animate-vibrate bg-green-500 p-2 rounded-full text-xs flex items-center justify-center transition-transform transform group-hover:animate-bounce md:hidden"
                >
                  <FaWhatsapp className="text-3xl" />
                </button>
              </div>
            )}
          </>
        )}
      </Formik>
      <Toaster />
    </div>
  );
};

export default ChatBot;
